module.exports = __webpack_public_path__ + "media/images/icons/variety-baf723476ad750e478f08a1b38c92c68.png";